import { Box } from '@mui/material';
import { useRouter } from 'next/router';
import { usePageName } from '../helpers/helpers';
import { useAuth } from "@videostream/route-this-login-react";
import Sidebar, { SIDEBAR_MARGIN } from './ui/Sidebar';
import Header from './ui/Header';
import { useCertifyTenant } from '../helpers/queryHelpers';
import { checkRoles } from "@videostream/role-checker";

export default function Layout(props) {
  const router = useRouter();
  const pageName = usePageName();
  const { currentUser } = useAuth();
  const { data: tenantData, isLoading: isTenantLoading } = useCertifyTenant(router.query.tenant_name);

  return (
    <Box sx={{ display: 'flex' }}>
      <Sidebar pageName={pageName} currentUser={currentUser} currentUserIsAdmin={checkRoles} />

      <Box
        sx={{
          ml: `${SIDEBAR_MARGIN}px`,
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
        }}
      >
        <Header pageName={pageName} tenantDisplayName={isTenantLoading ? '' : tenantData?.displayName} />
        <main>
          <Box sx={{ mt: '20px', pr: '44px' }}>{props.children}</Box>
        </main>
      </Box>
    </Box>
  );
}
